export default __webpack_public_path__ + "static/media/cart.57e96bbd.svg";